import PageTransition from "../components/v2/PageTransition";
import Wordmark from "../components/v2/Wordmark";
import "../components/v2/v2-question-surface.css";

function NoEntry18() {
  return (
    <span className="tgc-v2-age-pill__blocked-age">
      <svg
        aria-hidden="true"
        className="tgc-v2-age-pill__blocked-icon"
        viewBox="0 0 24 24"
        focusable="false"
      >
        <circle className="tgc-v2-age-pill__blocked-outline" cx="12" cy="12" r="8.5" />
        <path className="tgc-v2-age-pill__blocked-outline" d="M6.4 17.6 17.6 6.4" />
        <circle className="tgc-v2-age-pill__blocked-mark" cx="12" cy="12" r="8.5" />
        <path className="tgc-v2-age-pill__blocked-mark" d="M6.4 17.6 17.6 6.4" />
      </svg>
    </span>
  );
}

export default function Surface2({ direction = "forward", onContinue, onGoBack }) {
  return (
    <section className="tgc-v2-surface tgc-v2-surface--still" aria-labelledby="still-heading">
      <PageTransition direction={direction}>
        <div className="tgc-v2-still-shell">
          <Wordmark variant="stacked" />
          <div className="tgc-v2-still-copy">
            <h1 className="tgc-v2-still-heading" id="still-heading">You must be 18 or older.</h1>
            <p className="tgc-v2-still-body">
              This is an emotionally personal product, and we want to know it's reaching the right hands.
            </p>
          </div>
          <div className="tgc-v2-still-actions tgc-v2-age-actions">
            <button className="tgc-v2-age-pill tgc-v2-age-pill--primary" type="button" onClick={onContinue}>
              <span className="tgc-v2-age-pill__label">I'm 18 or older — continue</span>
            </button>
            <button className="tgc-v2-age-pill tgc-v2-age-pill--secondary" type="button" onClick={onGoBack}>
              <span className="tgc-v2-age-pill__subline">
                I'm not <NoEntry18 />
              </span>
            </button>
          </div>
        </div>
      </PageTransition>
    </section>
  );
}
